import { useEffect, useState } from 'react';
import CollaborateSection from '../components/CollaborateSection.jsx';
import ContactSection from '../components/ContactSection.jsx';
import EnablesSection from '../components/EnablesSection.jsx';
import Footer from '../components/Footer.jsx';
import HeroSection from '../components/HeroSection.jsx';
import ImpactSection from '../components/ImpactSection.jsx';
import ModelSection from '../components/ModelSection.jsx';
import NavBar from '../components/NavBar.jsx';
import OpportunitiesSection from '../components/OpportunitiesSection.jsx';
import PathSection from '../components/PathSection.jsx';
import ProcessSection from '../components/ProcessSection.jsx';
import ServicesSection from '../components/ServicesSection.jsx';
import StoriesSection from '../components/StoriesSection.jsx';

function Home() {
  const [selectedRole, setSelectedRole] = useState('');
  const [showRoleError, setShowRoleError] = useState(false);
  const [activeSection, setActiveSection] = useState('model');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 },
    );

    const animatedSections = document.querySelectorAll('.fade-up');
    animatedSections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll('[data-section]'));

    const handleScroll = () => {
      let currentSection = sections[0]?.id ?? '';

      sections.forEach((section) => {
        if (window.scrollY >= section.offsetTop - 140) {
          currentSection = section.id;
        }
      });

      setActiveSection((previousSection) =>
        previousSection === currentSection ? previousSection : currentSection,
      );
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!showRoleError) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setShowRoleError(false), 1600);
    return () => window.clearTimeout(timeoutId);
  }, [showRoleError]);

  const handleStart = () => {
    if (!selectedRole) {
      setShowRoleError(true);
      return;
    }

    window.alert(
      `Welcome, ${selectedRole}!\n\nA Trikon advisor will reach out with your personalised journey shortly.`,
    );
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
    if (showRoleError) {
      setShowRoleError(false);
    }
  };

  return (
    <>
      <NavBar activeSection={activeSection} />
      <HeroSection />
      <hr className="divider" />
      <ModelSection />
      <hr className="divider" />
      <StoriesSection />
      <hr className="divider" />
      <OpportunitiesSection />
      <ImpactSection />
      <ServicesSection />
      <hr className="divider" />
      <ProcessSection />
      <hr className="divider" />
      <EnablesSection />
      <hr className="divider" />
      <CollaborateSection />
      <hr className="divider" />
      <PathSection />
      <ContactSection
        selectedRole={selectedRole}
        showRoleError={showRoleError}
        onRoleChange={handleRoleChange}
        onStart={handleStart}
      />
      <Footer />
    </>
  );
}

export default Home;
